/**
 * @author bly
 * 模块说明：oss
 */
import { Service } from '@/tools'

export class OssService<T extends TUser.Oss> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TUser.Oss}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：获取OSS临时通行证
   * /api/user/oss/v1/getOssAuthorization
   */
  getOssAuthorization = <K extends T['ApiGetOssAuthorization']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetOssAuthorization', data)

  /**
   * 获取临时预签名下载地址
   * /api/user/oss/v1/generatePreSignature
   */
  generatePreSignature = <K extends T['ApiGeneratePreSignature']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGeneratePreSignature', data)
}
